import imgLogo from '../../assets/YIFavLogo.png'

export default class ImageUtils {
  static getAppLogoUrl() {
    return imgLogo
  }
}
